import { createFileRoute } from "@tanstack/react-router";
import OrganizationDetail from "@/features-root-user/organization/organization-detail/index";

export const Route = createFileRoute(
  "/_root/root-user/organization/organization/$id/detail",
)({
  component: OrganizationDetail,
});
